/* =====================================================
   Green Chick Chop — Location Based Store Selector
   gcc-store-locator.js
   ===================================================== */
(function () {
  "use strict";

  /* ---------------------------------------------------
     CONFIG — edit these two values before going live
  --------------------------------------------------- */
  var GCC_CONFIG = {
    // MSPL Store Locator API key (from API Access tab).
    // This is safe to expose client-side — protection comes from the
    // "Allowed Websites" domain allowlist on the API key, same model
    // as a Google Maps browser key.
    apiKey: "mspl_live_8e0f3df0f43f1ba378076090b5888f461f21ce9b",

    apiBaseUrl: "https://storelocator.metizapps.com/v2/api/front/nearby-stores",

    // Radius in km used for the "within X KM" search + copy.
    radiusKm: 4,

    // OPTIONAL: Google Geocoding API key, used to turn a manually typed
    // address into lat/lng with higher accuracy (the MSPL API itself
    // requires lat/lng, it does not accept free-text addresses).
    // Leave blank and manual-address entry automatically falls back to
    // the free OpenStreetMap Nominatim geocoder (no key needed, decent
    // for India, but rate-limited and less precise than Google).
    googleGeocodingApiKey: "AIzaSyDPWAlaX2lncOpAroEFFN0BmniCpavdJng",

    // URL of the Cloudflare Worker proxy that fetches real road distance
    // from Google Distance Matrix API. Required because Distance Matrix
    // API does not support being called directly from a browser (Google
    // sends no CORS headers on that endpoint — see distance-proxy-worker.js
    // for the full explanation and deploy steps). Leave blank to disable
    // road-distance lookups and fall back to MSPL's straight-line
    // distance everywhere.
    // Example once deployed: "https://gcc-distance-proxy.yoursubdomain.workers.dev"
    distanceMatrixProxyUrl: "",

    storageKey: "gcc_selected_store"
  };

  /* ---------------------------------------------------
     STATE
  --------------------------------------------------- */
  var state = {
    stores: [],
    selectedStore: null,
    // Accuracy (in meters) reported by the browser for the last
    // "Use Current Location" fix. Null when the last search came from a
    // geocoded manual address instead.
    lastAccuracyMeters: null,
    // Incremented on every new nearby-stores search. Used to discard the
    // result of an older, slower request if a newer one has already
    // started — otherwise a race between two overlapping searches (e.g.
    // from a double-bound event handler, or a fast double-click) can let
    // a stale/incorrect response overwrite a correct, more recent one.
    searchSeq: 0,
    // When true, the modal cannot be dismissed (no ✕, no backdrop click)
    // until a store is successfully selected. Used to force store
    // selection before a first-time visitor can use the rest of the site.
    requireSelection: false
  };

  /* ---------------------------------------------------
     DOM refs (queried once DOM is ready)
  --------------------------------------------------- */
  var els = {};

  function cacheEls() {
    els.overlay = document.getElementById("gccModalOverlay");
    els.close = document.getElementById("gccModalClose");
    els.pill = document.getElementById("gccLocationPill");
    els.pillValue = document.getElementById("gccPillValue");
    els.pillLabel = document.getElementById("gccPillLabel");

    els.useCurrentLocationBtn = document.getElementById("gccUseCurrentLocation");
    els.enterManuallyBtn = document.getElementById("gccEnterManually");

    els.addressForm = document.getElementById("gccAddressForm");
    els.findStoresBtn = document.getElementById("gccFindStoresBtn");

    els.storeList = document.getElementById("gccStoreList");
    els.selectStoreBtn = document.getElementById("gccSelectStoreBtn");
    els.storesFoundText = document.getElementById("gccStoresFoundText");
    els.accuracyNote = document.getElementById("gccAccuracyNote");
    els.radiusLabel = document.getElementById("gccRadiusLabel");

    els.tryAnotherBtn = document.getElementById("gccTryAnotherBtn");

    els.successName = document.getElementById("gccSuccessName");
    els.successAddr = document.getElementById("gccSuccessAddr");
    els.successDist = document.getElementById("gccSuccessDist");
    els.continueBtn = document.getElementById("gccContinueShoppingBtn");
  }

  /* ---------------------------------------------------
     STEP NAVIGATION
  --------------------------------------------------- */
  function showStep(stepName) {
    var steps = els.overlay.querySelectorAll(".gcc-modal__step");
    steps.forEach(function (el) {
      el.classList.toggle("is-active", el.getAttribute("data-step") === stepName);
    });
  }

  function openModal(stepName) {
    els.overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
    showStep(stepName || "select-location");
    els.close.style.display = state.requireSelection ? "none" : "";
  }

  function closeModal() {
    els.overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  /* ---------------------------------------------------
     PERSISTENCE
  --------------------------------------------------- */
  function saveStore(store) {
    try {
      localStorage.setItem(GCC_CONFIG.storageKey, JSON.stringify(store));
    } catch (e) { /* storage unavailable, non-fatal */ }
  }

  function loadStore() {
    try {
      var raw = localStorage.getItem(GCC_CONFIG.storageKey);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function updateHeaderPill(store) {
    if (!store) {
      els.pillLabel.textContent = "Delivering To";
      els.pillValue.textContent = "Select Location";
      return;
    }
    els.pillLabel.textContent = "Delivering to";
    els.pillValue.textContent = store.name;
  }

  /* ---------------------------------------------------
     API CALLS
  --------------------------------------------------- */
  function fetchNearbyStores(lat, lng) {
    var url = GCC_CONFIG.apiBaseUrl +
      "?lat=" + encodeURIComponent(lat) +
      "&lng=" + encodeURIComponent(lng) +
      "&radius=" + encodeURIComponent(GCC_CONFIG.radiusKm) +
      "&unit=km" +
      "&api_key=" + encodeURIComponent(GCC_CONFIG.apiKey);

    setListLoading(true);

    var thisSearchSeq = ++state.searchSeq;

    // NOTE: api_key is sent as a query param (not the X-API-Key header) on
    // purpose. Sending a custom header forces the browser to issue a CORS
    // preflight (OPTIONS) request first — and MSPL's endpoint currently
    // responds to that preflight with a redirect, which browsers refuse to
    // follow, breaking every request. A plain query-param GET avoids the
    // preflight entirely. If MSPL fixes the preflight redirect on their
    // side, switching back to the X-API-Key header is fine too.
    return fetch(url)
      .then(function (res) {
        if (!res.ok) {
          throw new Error("Store locator API error: " + res.status);
        }
        return res.json();
      })
      .then(function (data) {
        if (thisSearchSeq !== state.searchSeq) return []; // a newer search superseded this one
        return (data && data.stores) || [];
      })
      .then(function (stores) {
        if (thisSearchSeq !== state.searchSeq) return stores;
        // MSPL's `distance` is straight-line ("as the crow flies"), which
        // can be meaningfully shorter than the real drivable distance —
        // e.g. a store across a park or canal can look close on a straight
        // line but require a long detour by road. Look up actual road
        // distance/time for every candidate in one batched request, then
        // re-filter/sort/display using that instead.
        return enrichStoresWithRoadDistance(lat, lng, stores);
      })
      .then(function (stores) {
        if (thisSearchSeq !== state.searchSeq) return;
        // Straight-line distance is always <= road distance, so MSPL's
        // own radius filter can only ever be a superset of what a road-
        // distance radius filter would allow — safe to tighten here
        // without needing to widen MSPL's search radius upstream.
        state.stores = stores.filter(function (s) {
          return s.distanceByRoad <= GCC_CONFIG.radiusKm;
        });
      })
      .catch(function (err) {
        // Only a genuine network/API failure lands here — state.stores is
        // only reset to [] for a real fetch failure, never because of a
        // rendering bug (see the separate .then below).
        console.error("Nearby-stores request failed:", err);
        if (thisSearchSeq !== state.searchSeq) return;
        state.stores = [];
      })
      .then(function () {
        if (thisSearchSeq !== state.searchSeq) return; // stale — don't render over a newer result
        // Deliberately outside the catch above: if renderResults() itself
        // throws (e.g. a DOM element missing from an out-of-date theme
        // file), that error surfaces in the console instead of silently
        // being reinterpreted as "no stores found" and wiping real results.
        renderResults();
      })
      .finally(function () {
        if (thisSearchSeq !== state.searchSeq) return;
        setListLoading(false);
      });
  }

  // Look up real driving distance/time from (lat,lng) to every candidate
  // store in ONE batched request (Distance Matrix accepts multiple
  // destinations per call — far cheaper than one request per store).
  // Adds `distanceByRoad` (km) and `durationText` (e.g. "12 mins") to
  // each store object. Falls back to MSPL's straight-line `distance` if
  // no Google key is configured, or if the Distance Matrix call fails for
  // any reason — this must never leave a store without distanceByRoad,
  // since renderResults()/filtering downstream depend on that field.
  function enrichStoresWithRoadDistance(lat, lng, stores) {
    if (!stores.length) {
      return Promise.resolve(stores);
    }
    if (!GCC_CONFIG.distanceMatrixProxyUrl) {
      stores.forEach(function (s) { s.distanceByRoad = s.distance; s.durationText = null; });
      return Promise.resolve(stores);
    }

    var destinations = stores.map(function (s) { return s.lat + "," + s.lng; }).join("|");
    // NOTE: calling our own Cloudflare Worker proxy here, NOT Google
    // directly. Google's Distance Matrix API sends no CORS headers, so a
    // direct browser call is blocked outright regardless of API key
    // settings — see distance-proxy-worker.js for the full explanation.
    // The proxy holds the Google key server-side and returns the same
    // JSON shape Google would, so the parsing below is unchanged.
    var url = GCC_CONFIG.distanceMatrixProxyUrl +
      "?origin=" + encodeURIComponent(lat + "," + lng) +
      "&destinations=" + encodeURIComponent(destinations);

    return fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status !== "OK" || !data.rows || !data.rows[0]) {
          throw new Error("Distance Matrix failed: " + data.status + (data.error_message ? " — " + data.error_message : ""));
        }
        var elements = data.rows[0].elements;
        stores.forEach(function (s, i) {
          var el = elements[i];
          if (el && el.status === "OK") {
            s.distanceByRoad = el.distance.value / 1000; // meters -> km
            s.durationText = el.duration.text;
          } else {
            // No drivable route found for this one store (e.g. blocked
            // by water with no bridge) — fall back to straight-line
            // rather than silently dropping it from the list.
            s.distanceByRoad = s.distance;
            s.durationText = null;
          }
        });
        return stores;
      })
      .catch(function (err) {
        console.warn("Road-distance lookup failed, falling back to straight-line distance:", err);
        stores.forEach(function (s) { s.distanceByRoad = s.distance; s.durationText = null; });
        return stores;
      });
  }


  // The MSPL API only accepts coordinates, so manual-address entry needs
  // this extra hop.
  //
  // `candidates` is an array of query strings ordered from most specific
  // to least specific (e.g. full address, then area+city+pincode, then
  // just city+pincode). We try each in turn because free geocoders (and
  // Nominatim especially) often fail to match informal Indian addresses
  // that include a house/flat number, but succeed once the query is
  // simplified to just the locality/pincode.
  function geocodeAddress(candidates) {
    if (GCC_CONFIG.googleGeocodingApiKey) {
      return geocodeWithGoogle(candidates[0]).catch(function (err) {
        // Google can reject for account/key reasons (e.g. a referrer-restricted
        // key, which Google disallows for server-side APIs like Geocoding)
        // as well as genuine no-match cases. Either way, don't dead-end —
        // fall back to the free geocoder instead of failing the search.
        console.warn("Google geocoding failed, falling back to Nominatim:", err);
        return geocodeWithNominatim(candidates, 0);
      });
    }
    return geocodeWithNominatim(candidates, 0);
  }

  function geocodeWithGoogle(addressString) {
    var googleUrl = "https://maps.googleapis.com/maps/api/geocode/json?address=" +
      encodeURIComponent(addressString) +
      "&key=" + GCC_CONFIG.googleGeocodingApiKey;

    return fetch(googleUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data.status !== "OK" || !data.results.length) {
          throw new Error("Google geocoding failed: " + data.status + (data.error_message ? " — " + data.error_message : ""));
        }
        var loc = data.results[0].geometry.location;
        return { lat: loc.lat, lng: loc.lng };
      });
  }

  function geocodeWithNominatim(candidates, attemptIndex) {
    if (attemptIndex >= candidates.length) {
      return Promise.reject(new Error("geocode-not-found"));
    }
    var query = candidates[attemptIndex];
    var url = "https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=in&q=" +
      encodeURIComponent(query);

    return fetch(url, { headers: { "Accept": "application/json" } })
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data || !data.length) {
          // Try the next, simpler candidate query instead of giving up.
          return geocodeWithNominatim(candidates, attemptIndex + 1);
        }
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      });
  }

  /* ---------------------------------------------------
     RENDERING
  --------------------------------------------------- */
  function setListLoading(isLoading) {
    if (isLoading) {
      els.storeList.innerHTML = '<li class="gcc-inline-loading"><span class="gcc-spinner"></span> Finding nearby stores…</li>';
      els.selectStoreBtn.disabled = true;
    }
  }

  function renderResults() {
    els.radiusLabel.textContent = GCC_CONFIG.radiusKm;

    if (!state.stores.length) {
      showStep("no-stores");
      return;
    }

    // Sort by real road distance now, not MSPL's straight-line distance.
    state.stores.sort(function (a, b) { return a.distanceByRoad - b.distanceByRoad; });

    els.storesFoundText.textContent = "We found " + state.stores.length + " store" +
      (state.stores.length > 1 ? "s" : "") + " near you";

    // Warn the customer if the browser's location fix was low-precision
    // (common on desktops/laptops without GPS, or on VPNs) — the nearby
    // list below may not reflect their real position in that case.
    // Guarded with `if (els.accuracyNote)` on purpose: this element only
    // exists if the theme has the latest gcc-store-locator.liquid. If an
    // older version of that file is still in place, this must NOT throw —
    // a thrown error here would bubble up into the calling promise chain's
    // .catch() and incorrectly wipe out perfectly good store results.
    if (els.accuracyNote) {
      if (state.lastAccuracyMeters && state.lastAccuracyMeters > 1000) {
        var km = (state.lastAccuracyMeters / 1000).toFixed(1);
        els.accuracyNote.textContent =
          "Your device's location signal is approximate (±" + km + " km), so these results may be off. " +
          "If this doesn't look right, try 'Enter Delivery Address Manually' instead.";
        els.accuracyNote.style.display = "block";
      } else {
        els.accuracyNote.style.display = "none";
      }
    }

    els.storeList.innerHTML = "";
    state.stores.forEach(function (store, idx) {
      var li = document.createElement("li");
      li.className = "gcc-store-item";
      li.setAttribute("data-store-id", store.id);
      li.innerHTML =
        '<input type="radio" name="gccStoreChoice" id="gccStore' + store.id + '"' + (idx === 0 ? " checked" : "") + '>' +
        '<div class="gcc-store-item__info">' +
          '<div class="gcc-store-item__name">' + escapeHtml(store.name) + '</div>' +
          '<div class="gcc-store-item__addr">' + escapeHtml(store.address) + (store.city ? ", " + escapeHtml(store.city) : "") + '</div>' +
        '</div>' +
        '<div class="gcc-store-item__dist">' + Number(store.distanceByRoad).toFixed(1) + ' KM' +
          (store.durationText ? '<div class="gcc-store-item__time">' + escapeHtml(store.durationText) + '</div>' : '') +
        '</div>';

      li.addEventListener("click", function () {
        selectListItem(store);
      });
      els.storeList.appendChild(li);
    });

    // Pre-select the nearest store.
    selectListItem(state.stores[0]);
    showStep("nearby-stores");
  }

  function selectListItem(store) {
    state.selectedStore = store;
    els.selectStoreBtn.disabled = false;
    var items = els.storeList.querySelectorAll(".gcc-store-item");
    items.forEach(function (item) {
      var isMatch = item.getAttribute("data-store-id") === String(store.id);
      item.classList.toggle("is-selected", isMatch);
      var radio = item.querySelector("input[type=radio]");
      if (radio) radio.checked = isMatch;
    });
  }

  function escapeHtml(str) {
    var div = document.createElement("div");
    div.textContent = str || "";
    return div.innerHTML;
  }

  /* ---------------------------------------------------
     EVENT HANDLERS
  --------------------------------------------------- */
  function handleUseCurrentLocation() {
    if (!navigator.geolocation) {
      alert("Your browser does not support location access. Please enter your address manually.");
      showStep("manual-address");
      return;
    }

    var btn = els.useCurrentLocationBtn;
    var originalLabel = btn.querySelector("span").textContent;
    btn.disabled = true;
    btn.querySelector("span").textContent = "Detecting your location…";

    navigator.geolocation.getCurrentPosition(
      function (pos) {
        btn.disabled = false;
        btn.querySelector("span").textContent = originalLabel;
        state.lastAccuracyMeters = pos.coords.accuracy || null;
        fetchNearbyStores(pos.coords.latitude, pos.coords.longitude);
      },
      function () {
        btn.disabled = false;
        btn.querySelector("span").textContent = originalLabel;
        alert("We couldn't access your location. Please enter your address manually.");
        showStep("manual-address");
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  }

  function handleManualAddressSubmit(e) {
    e.preventDefault();

    var form = els.addressForm;
    var area = form.area.value.trim();
    var city = form.city.value.trim();
    var pincode = form.pincode.value.trim();
    var houseNo = form.houseNo.value.trim();
    var landmark = form.landmark.value.trim();

    var valid = true;
    toggleFieldError(form.area, !area);
    toggleFieldError(form.city, !city);
    toggleFieldError(form.pincode, !/^\d{6}$/.test(pincode));
    valid = area && city && /^\d{6}$/.test(pincode);
    if (!valid) return;

    // Build fallback candidates, cleanest/most reliable first.
    //
    // Deliberately geocoding on area+city+pincode FIRST, without the house
    // number or landmark: those extra tokens have no formal representation
    // in most geocoding databases for Indian addresses, and rather than
    // failing cleanly, they can cause the geocoder to snap to a DIFFERENT
    // plausible-sounding nearby locality (e.g. "Sector 82" search polluted
    // with a house number resolving to "Sector 110" instead) — a wrong but
    // non-empty match, which our old most-specific-first order would have
    // accepted immediately without ever trying a cleaner query.
    var candidates = [
      [area, city, pincode, "India"].filter(Boolean).join(", "),
      [area, landmark, city, pincode, "India"].filter(Boolean).join(", "),
      [city, pincode, "India"].filter(Boolean).join(", "),
      [pincode, "India"].filter(Boolean).join(", ")
    ];
    // De-duplicate in case some fields were blank and two candidates match.
    candidates = candidates.filter(function (c, i) { return candidates.indexOf(c) === i; });

    var btn = els.findStoresBtn;
    btn.disabled = true;
    btn.querySelector(".gcc-btn-label").textContent = "Finding stores…";

    geocodeAddress(candidates)
      .then(function (coords) {
        state.lastAccuracyMeters = null; // geocoded address, not a GPS/WiFi fix
        return fetchNearbyStores(coords.lat, coords.lng);
      })
      .catch(function (err) {
        console.error(err);
        alert("We couldn't locate that address automatically. Please double-check it, or use 'Use Current Location' instead.");
      })
      .finally(function () {
        btn.disabled = false;
        btn.querySelector(".gcc-btn-label").textContent = "Find Nearby Stores";
      });
  }

  function toggleFieldError(inputEl, hasError) {
    var wrapper = inputEl.closest(".gcc-field");
    if (wrapper) wrapper.classList.toggle("has-error", !!hasError);
  }

  // Push the selected store onto the Shopify cart as attributes, so it
  // travels through checkout and shows up on the order in admin (under
  // "Additional details" on the order page). Cart attributes are the
  // standard way to attach non-product data like this to an order.
  function syncStoreToCart(store) {
    return fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          "Selected Store": store.name,
          "Store Address": store.address + (store.city ? ", " + store.city : ""),
          "Store ID": String(store.id),
          "Store Distance (km, by road)": Number(store.distanceByRoad).toFixed(1),
          "Estimated Drive Time": store.durationText || ""
        }
      })
    }).catch(function (err) {
      // Non-fatal: store selection still works client-side even if this
      // particular sync call fails (e.g. no cart/session yet).
      console.error("Could not sync store to cart attributes:", err);
    });
  }

  function handleSelectStore() {
    if (!state.selectedStore) return;
    var store = state.selectedStore;

    els.successName.textContent = store.name;
    els.successAddr.textContent = store.address + (store.city ? ", " + store.city : "");
    els.successDist.textContent = Number(store.distanceByRoad).toFixed(1) + " KM away" +
      (store.durationText ? " (~" + store.durationText + " by road)" : "");

    saveStore(store);
    updateHeaderPill(store);
    syncStoreToCart(store);
    state.requireSelection = false;
    els.close.style.display = "";
    showStep("success");

    document.dispatchEvent(new CustomEvent("gcc:store-selected", { detail: store }));
  }

  /* ---------------------------------------------------
     INIT
  --------------------------------------------------- */
  function bindEvents() {
    els.pill.addEventListener("click", function () {
      openModal(state.selectedStore ? "select-location" : "select-location");
    });
    els.close.addEventListener("click", function () {
      if (state.requireSelection) return;
      closeModal();
    });
    els.overlay.addEventListener("click", function (e) {
      if (e.target === els.overlay && !state.requireSelection) closeModal();
    });

    els.useCurrentLocationBtn.addEventListener("click", handleUseCurrentLocation);
    els.enterManuallyBtn.addEventListener("click", function () { showStep("manual-address"); });

    els.addressForm.addEventListener("submit", handleManualAddressSubmit);
    els.selectStoreBtn.addEventListener("click", handleSelectStore);
    els.tryAnotherBtn.addEventListener("click", function () { showStep("select-location"); });
    els.continueBtn.addEventListener("click", closeModal);
  }

  function init() {
    // Guards against the snippet's <script> tag being loaded more than
    // once on the same page (e.g. accidentally rendered on two header
    // rows). Without this, every button click would fire two independent
    // search requests, and whichever response arrives last — even a
    // stale/incorrect one — would win, causing valid results to appear
    // to "disappear."
    if (window.__gccStoreLocatorInitialized) {
      console.warn("gcc-store-locator.js loaded more than once on this page — skipping duplicate init. Check that {% render 'gcc-store-locator' %} only appears once in your header.");
      return;
    }
    window.__gccStoreLocatorInitialized = true;

    cacheEls();
    bindEvents();

    var saved = loadStore();
    if (saved) {
      state.selectedStore = saved;
      updateHeaderPill(saved);
      syncStoreToCart(saved); // re-sync in case this is a fresh cart/session
    } else {
      updateHeaderPill(null);
      // First-time visitor: force store selection before they can use
      // the rest of the site — no ✕, no backdrop-click dismissal.
      state.requireSelection = true;
      openModal("select-location");
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  // Expose for other theme scripts (e.g. cart/checkout can read the
  // currently selected store).
  window.GCCStoreLocator = {
    getSelectedStore: function () { return loadStore(); },
    open: openModal
  };
})();